<template>
  <BRow>
    <BCol lg="12">
      <BCard no-body>
        <BCardBody>
          <div v-if="loading" class="text-center py-5">
            <div class="spinner-border" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
          <div v-else-if="error" class="alert alert-danger">
            {{ error }}
          </div>
          <UserForm
            v-else
            title="Modifier un Utilisateur"
            submitButtonText="Modifier un Utilisateur"
            mode="update"
            :user="user"
            @user-submit="updateUser"
            @cancel="handleCancel"
          />
        </BCardBody>
      </BCard>
    </BCol>
  </BRow>
</template>

<script>
import UserForm from '@/components/UserForm.vue';
import { userService } from '@/shared/services/user.service';
import notificationService from '@/shared/services/notification.service';

export default {
  name: 'UpdateUser',

  components: {
    UserForm,
  },

  data() {
    return {
      user: null,
      loading: true,
      error: null,
    };
  },

  async mounted() {
    await this.fetchUser();
  },

  methods: {
    async fetchUser() {
      this.loading = true;
      this.error = null;

      try {
        const userId = this.$route.params.id;
        if (!userId) {
          throw new Error('User ID is required');
        }
        const response = await userService.getUser(userId);
        this.user = response;
        if (!this.user) {
          this.error = 'User not found.';
        }
      } catch (error) {
        console.error('Error fetching user:', error);
        this.error = 'Failed to load user data. Please try again.';
      } finally {
        this.loading = false;
      }
    },

    async updateUser(formData) {
      try {
        const userId = this.$route.params.id;

        // Exclude email from update data
        const updateData = {
          lastName: formData.lastName,
          firstName: formData.firstName,
          phone: formData.phone,
          role_name: formData.role_name,
        };
        await userService.updateUser(userId, updateData);
        notificationService.successAction('update', 'user');
        this.$router.push('/users');
      } catch (error) {
        console.error('Error updating user:', error);
        const details =
          error.response?.data?.message ||
          "Erreur lors de la modification de l'utilisateur";
        notificationService.errorAction('update', 'user', details);
      }
    },

    handleCancel() {
      this.$router.push('/users');
    },
  },
};
</script>
